import { render, staticRenderFns } from "./PromotionFlow.vue?vue&type=template&id=b69b95f2&"
import script from "./PromotionFlow.vue?vue&type=script&lang=js&"
export * from "./PromotionFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports